import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { BreadcrumbService } from './breadcrumb.service';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-new-breadcrumb',
  standalone: true,
  imports: [MatIcon, TranslateModule, RouterLink],
  templateUrl: './new-breadcrumb.component.html',
  styleUrl: './new-breadcrumb.component.scss'
})
export class NewBreadcrumbComponent {
  constructor(public breadcrumbService: BreadcrumbService) {}
}
